export const SERVICE = {
    L2M_NCT: 'lineage2mnct',
    L2M_NCJ: 'lineage2mncj',
    L2M_SA: 'lineage2msa'
};

export const getService = () => {
  return document.documentElement.dataset.service || window?.userData?.site;
};
